import axios from "axios";
import React, { useState } from "react";
import {
  MDBBtn,
  MDBContainer,
  MDBCard,
  MDBCardBody,
  MDBInput,
  MDBIcon,
} from "mdb-react-ui-kit";
import baner from "../img/BANNER.jpg";

function Formulario() {
  const [correo, setCorreo] = useState([]);

  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  const hacerGET = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (emailRegex.test(correo)) {
      // URL a la que deseas hacer la solicitud GET
      const url =
        "https://apioraclecpqicontec.azurewebsites.net/api/ServicioHabeas/" +
        correo;
      axios
        .get(url)
        .then((response) => {
          // Maneja la respuesta exitosa aquí
          setData(response.data);
          window.alert(response.data);
          window.location.href = "/#/confirma";
        })
        .catch((error) => {
          // Maneja los errores aquí
          setError(error);
        });
    } else {
      window.alert("Correo electrónico incorrecto");
    }
  };
  return (
    <MDBContainer fluid>
      <div
        className="p-5 bg-image"
        style={{
          backgroundImage: `url(${baner})`,
          height: "300px",
        }}
      ></div>

      <MDBCard
        className="mx-5 mb-5 p-5 shadow-5"
        style={{
          marginTop: "-100px",
          background: "hsla(0, 0%, 100%, 0.8)",
          backdropFilter: "blur(30px)",
        }}
      >
        <MDBCardBody className="p-5 text-center">
          <h1 className="fw-bold mb-5">
            Dejar de recibir notificaciones de Icontec
          </h1>
          <h3>
            Ingrese su correo electrónico aquí para dejar de recibir correos con
            información de Icontec.
          </h3>

          <input
            type="email"
            className="form-control form-control-user"
            placeholder="Correo Electronico"
            onChange={(e) => {
              const correo = e.target.value;
              const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

              if (emailRegex.test(correo)) {
                // La dirección de correo electrónico es válida
                setCorreo(correo);
              } else {
                // La dirección de correo electrónico no es válida
                // Puedes manejar esto mostrando un mensaje de error o realizando otra acción
                console.error("Dirección de correo electrónico no válida");
              }
            }}
          />
          <hr />
          <button
            className="btn btn-primary btn-user btn-block"
            onClick={hacerGET}
          >
            {" "}
            Dejar de recibir notificaciones a mi correo electrónico
          </button>

          <div className="text-center">
            <MDBBtn
              tag="a"
              color="none"
              className="mx-3"
              style={{ color: "#1266f1" }}
            >
              <MDBIcon fab icon="facebook-f" size="sm" />
            </MDBBtn>
            <MDBBtn
              tag="a"
              color="none"
              className="mx-3"
              style={{ color: "#1266f1" }}
            >
              <MDBIcon fab icon="twitter" size="sm" />
            </MDBBtn>

            <MDBBtn
              tag="a"
              color="none"
              className="mx-3"
              style={{ color: "#1266f1" }}
            >
              <MDBIcon fab icon="google" size="sm" />
            </MDBBtn>

            <MDBBtn
              tag="a"
              color="none"
              className="mx-3"
              onClick={hacerGET}
              style={{ color: "#1266f1" }}
            >
              <MDBIcon fab icon="github" size="sm" />
            </MDBBtn>
          </div>
        </MDBCardBody>
      </MDBCard>
    </MDBContainer>
  );
}

export default Formulario;
